<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 d-inline-block mb-0">
            {{ $t("number.agent") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">{{ $t("number.agent_create") }}</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- Form groups used in grid -->

          <form>
            <div class="form-group row" v-if="isDtacAdmin">
              <label
                for="number-corporate"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("menu.corporate") }} *</label
              >
              <div class="col-md-10">
                <base-input
                  input-classes="form-control-alternative new-event--title"
                >
                  <el-select id="number-corporate"
                    v-model="create.corporate"
                    :placeholder="$t('menu.corporate')"
                    filterable
                  >
                    <el-option
                      v-for="option in corporate"
                      :key="option.label"
                      :label="option.Name"
                      :value="option.ID"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="form-group row">
              <label
                for="number-charge"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("number.charge") }}</label
              >
              <div class="col-md-10">
                <form class="new-event--form" @submit.prevent="saveEvent">
                  <base-input
                    input-classes="form-control-alternative new-event--title"
                  >
                    <el-select id="number-charge"
                      v-model="create.charge_number"
                      :placeholder="$t('number.charge')"
                    >
                      <el-option
                        v-for="option in optionChargeNumber"
                        :key="option.label"
                        :label="option.label"
                        :value="option.value"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </form>
              </div>
            </div>
            <div class="form-group row">
              <label for="number-agent" class="col-md-2 col-form-label form-control-label">{{
                $t("number.agent")
              }} *</label>
              <div class="col-md-10">
                <base-input id="number-agent" placeholder="" v-model="create.number"></base-input>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="email"
                class="col-md-2 col-form-label form-control-label"
                >{{ $t("email_optional") }}</label
              >
              <div class="col-md-10">
                <base-input
                  id="email"
                  v-model="create.email"
                />
              </div>
            </div>

            <div class="form-group row">
              <div class="offset-md-2 col-md-10">
                <base-button size="sm" type="neutral" @click="handleCreate()">{{
                  $t("save")
                }}</base-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNumber",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      corporate: "Corporate/getData"
    })
  },
  data() {
    return {
      optionChargeNumber: [
        {
          label: this.$t("menu.pilot_number"),
          value: 1
        },
        {
          label: this.$t("menu.agent_number"),
          value: 2
        }
      ],

      create: {
        corporate: null,
        number: "",
        charge_number: 1,
        email: ""
      }
    };
  },
  mounted() {
    this.listCorporate();
  },
  methods: {
    ...mapActions({
      createData: "AgentNumberV4/createData",
      updateData: "AgentNumberV4/updateData",
      deleteData: "AgentNumberV4/deleteData",
      listCorporate: "Corporate/listData"
    }),
    handleCreate() {
      this.createData({
        enterpriseID: this.create.corporate,
        number: this.create.number,
        chargeFrom: this.create.charge_number,
        email: this.create.email
      })
        .then(resp => {
          swal
            .fire({
              title: this.$t("number.create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              this.$router.push({ name: "agent_number" });
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t(err.response.data.Msg),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.2rem !important;
}
</style>
